import { LocalStorageKeys } from "@/shared/constants/local-storage-keys";

import { localStorageCheck } from "./local-storage-check";

export const getFromLocalStorage = (name: LocalStorageKeys) => {
	let result = null;
	if (localStorageCheck() && window.localStorage?.getItem(name)) {
		result = window.localStorage.getItem(name) as string;
	}
	return result;
};
